import BaseApi from '~/api/base';
class DocumentComparisonsComments extends BaseApi {
    constructor() {
        super('/document-comparison/comment');
    }
    getById(id) {
        return super.route('/document-comparison/comments').getById(id);
    }
}
const DocumentComparisonsCommentsApi = new DocumentComparisonsComments();
export default DocumentComparisonsCommentsApi;
